export default (
  state = {
    langDropdownOpen: false,
    lang: "en",
    submitted: false,
    subscriberkey: null
  },
  action
) => {
  switch (action.type) {
    case "SET_LANG":
      return {
        ...state,
        ...{ lang: action.payload }
      };
    case "SET_SUBSCRIBER":
      return {
        ...state,
        ...{ subscriberkey: action.payload }
      };
    case "LANG_DROPDOWN":
      return {
        ...state,
        ...{ langDropdownOpen: action.payload }
      };
    case "SUBMIT":
      return {
        ...state,
        ...{ submitted: action.payload }
      };
    default:
      return state;
  }
};
